module.exports = __webpack_public_path__ + "img/左对齐3.bdfaf2fa.svg";